<div>
        <dp-loading-spinner *ngIf="isLoading" [message]="loadingMessage" />

        <form #form="ngForm" (ngSubmit)="save(form)">
            <div class="row">
                <div class="col-md-6">
                    <div class="mb-3">
                        <dprep-input [(ngModel)]="client.firstName"
                                     [maxLength]="50"
                                     [required]="true"
                                     [form]="form"
                                     name="firstName"
                                     label="First Name" />
                        <dprep-validation-field [form]="form" name="firstName" label="First Name" />
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="mb-3">
                        <dprep-input [(ngModel)]="client.lastName"
                                     [maxLength]="50"
                                     [required]="true"
                                     [form]="form"
                                     name="lastName"
                                     label="Last Name" />
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="mb-3">
                        <dprep-input [ngModel]="client.primaryEmail?.text"
                                     (ngModelChange)="primaryEmailChanged($event)"
                                     [required]="true"
                                     [form]="form"
                                     name="primaryEmail.text"
                                     label="Primary Email"
                                     type="email" />
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="mb-3">
                        <dprep-input id="gender"
                                     type="select"
                                     label="Gender"
                                     [(ngModel)]="client.gender"
                                     name="gender"
                                     [form]="form">
                            <option value=""></option>
                            <option [value]="genderType.Unspecified">Unspecified</option>
                            <option [value]="genderType.Male">Male</option>
                            <option [value]="genderType.Female">Female</option>
                        </dprep-input>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="mb-3" *ngIf="client.primaryPhone">
                        <dprep-input [(ngModel)]="client.primaryPhone.text"
                                     (ngModelChange)="phoneNumberChanged($event)"
                                     [maxLength]="50"
                                     [form]="form"
                                     name="primaryPhone.text"
                                     label="Phone Number" />
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="mb-3">
                        <dprep-input [(ngModel)]="client.addressLine1"
                                     [maxLength]="100"
                                     [form]="form"
                                     name="addressLine1"
                                     label="Address Line 1" />
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="mb-3">
                        <dprep-input [(ngModel)]="client.addressLine2"
                                     [form]="form"
                                     [maxLength]="100"
                                     name="addressLine2"
                                     label="Address Line 2" />
                        <dprep-validation-field [form]="form" name="addressLine2" label="Address Line 2" />
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <div class="mb-3">
                        <dprep-input [(ngModel)]="client.city"
                                     [maxLength]="100"
                                     [form]="form"
                                     name="city"
                                     label="City" />
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="mb-3">
                        <dprep-input type="select"
                                     id="stateId"
                                     [ngModel]="client.state?.id"
                                     (ngModelChange)="stateChanged($event)"
                                     [form]="form"
                                     name="state"
                                     label="State">
                            <option value=""></option>
                            <option *ngFor="let state of states" [value]="state.id">
                                {{ state.name }}
                            </option>
                        </dprep-input>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="mb-6">
                        <dprep-input [(ngModel)]="client.postalCode"
                                     [maxLength]="10"
                                     [form]="form"
                                     name="postalCode"
                                     label="Postal Code" />
                    </div>
                </div>
            </div>

            <div class="mt-3">
                <dprep-validation-summary [form]="form" [validationErrors]="validationErrors" />

                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-secondary me-2" (click)="cancel()">
                        Cancel
                    </button>
                    <button type="submit" class="btn btn-primary">
                        Save
                    </button>
                </div>
            </div>
        </form>
</div>
